import { motion } from "framer-motion";

const chapters = [
  {
    no: "01",
    title: "Coffee & Cars",
    body: "More than a car show. Grab a coffee, roll in early, and hang out with the coolest cars and friendliest people — every Saturday morning.",
  },
  {
    no: "02",
    title: "Quality Over Crowds",
    body: "Every car is welcome and every guest matters. We keep it chill and personal instead of packed and noisy.",
  },
  {
    no: "03",
    title: "More Than Cars",
    body: "Cars, coffee, breakfast and good vibes. Live builds, chats with builders, and easy mornings just hanging out.",
  },
  {
    no: "04",
    title: "The Good Stuff Lasts",
    body: "The friendships stick around long after the show ends. People stay in touch, help each other out, and make real friends.",
  },
];

const fade = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: i * 0.08 },
  }),
};

export default function Manifesto() {
  return (
    <section data-testid="manifesto-section" id="manifesto" className="bg-background py-24 md:py-32">
      <div className="mx-auto max-w-[1600px] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="mb-16 flex flex-col justify-between gap-6 md:flex-row md:items-end"
        >
          <div>
            <span className="font-body text-xs uppercase tracking-[0.3em] text-primary">About Us</span>
            <h2 className="mt-4 max-w-2xl font-display text-4xl font-extrabold tracking-tight text-white md:text-6xl">
              A place where <span className="font-serif-italic font-medium italic text-white/60">car lovers</span> feel at home.
            </h2>
          </div>
          <p className="max-w-xs font-body text-base text-white/50">
            Four simple things we care about at every show.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 border-t border-white/10 md:grid-cols-2">
          {chapters.map((c, i) => (
            <motion.div
              key={c.no}
              data-testid={`manifesto-chapter-${c.no}`}
              custom={i}
              variants={fade}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              className="group border-b border-white/10 p-8 transition-colors duration-500 hover:bg-white/[0.02] md:p-12 md:[&:nth-child(odd)]:border-r"
            >
              <div className="flex items-start gap-6">
                <span className="font-display text-5xl font-extrabold text-white/10 transition-colors duration-500 group-hover:text-primary md:text-7xl">
                  {c.no}
                </span>
                <div className="pt-2">
                  <h3 className="font-display text-2xl font-bold text-white md:text-3xl">{c.title}</h3>
                  <p className="mt-4 max-w-md font-body text-base leading-relaxed text-white/60">{c.body}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
